/**
 * Module de rendu des aspects entre planètes
 */
import { adjustColorOpacity } from '../core/utils.js';
import { ASPECT_CONFIG } from '../core/constants.js';

export class AspectRenderer {
    /**
     * @param {CanvasRenderingContext2D} ctx - Contexte 2D du canvas
     * @param {Object} options - Options de configuration
     */
    constructor(ctx, options) {
        this.ctx = ctx;
        this.options = options;
        this.aspectConfig = ASPECT_CONFIG;
    }

    /**
     * Dessine les aspects entre les planètes
     * @param {Array} aspects - Liste des aspects à dessiner
     * @param {Object} planetPositions - Positions des planètes
     */
    draw(aspects, planetPositions) {
        if (!aspects || !aspects.length) return;

        const ctx = this.ctx;

        // Pour chaque aspect, tracer une ligne entre les planètes
        aspects.forEach(aspect => {
            const planet1 = planetPositions[aspect.point1];
            const planet2 = planetPositions[aspect.point2];

            // Vérifier que les deux planètes ont des coordonnées
            if (planet1 && planet2 && 'x' in planet1 && 'y' in planet1 && 'x' in planet2 && 'y' in planet2) {
                // Configurer le style selon le type d'aspect
                const aspectStyle = this.aspectConfig[aspect.type] || { color: '#e6bfa4', width: 0.5, dash: [1, 1] };

                // Ajuster l'opacité selon la force de l'aspect
                const opacity = Math.abs(aspect.effectiveStrength) * 0.7 + 0.3; // Entre 0.3 et 1

                // Épaisseur ajustée selon la force
                const adjustedWidth = aspectStyle.width * (Math.abs(aspect.effectiveStrength) * 0.5 + 0.5);

                ctx.beginPath();
                ctx.moveTo(planet1.x, planet1.y);
                ctx.lineTo(planet2.x, planet2.y);
                ctx.strokeStyle = adjustColorOpacity(aspectStyle.color, opacity);
                ctx.lineWidth = adjustedWidth;
                ctx.setLineDash(aspectStyle.dash);
                ctx.stroke();
                ctx.setLineDash([]);
            }
        });
    }
}